import { createSlice } from '@reduxjs/toolkit';

import { OrderStatusFilter } from 'types/order';

import type { RootState } from 'features/store/store';

import type { PayloadAction } from '@reduxjs/toolkit';

interface instagramOrdersState {
  search: string;
  statusFilter: OrderStatusFilter;
}

const initialState: instagramOrdersState = {
  search: '',
  statusFilter: 'ALL',
};

export const instagramOrdersSlice = createSlice({
  name: 'instagramOrdersSlice',
  initialState,
  reducers: {
    setInstagramOrdersSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setInstagramOrdersStatusFilter: (state, action: PayloadAction<OrderStatusFilter>) => {
      state.statusFilter = action.payload;
    },
    resetFiltersInstagramOrdersFilter: (state) => {
      return initialState;
    },
  },
});

export const instagramOrdersActions = instagramOrdersSlice.actions;

export const selectInstagramOrders = (state: RootState) => state.instagramOrders;

export default instagramOrdersSlice.reducer;
